var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_854_13750)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4294 46C52.5643 46 50.4443 48.5077 50.5392 51.2272C50.6303 53.84 50.5119 57.2238 49.6601 59.9834C48.8052 62.7507 47.3604 64.5043 45 64.7294V67.2706C47.3604 67.4962 48.8052 69.2489 49.66 72.0166C50.5119 74.7762 50.6302 78.16 50.5391 80.7728C50.4442 83.4919 52.5642 86 55.4298 86H84.7873C87.6524 86 89.772 83.4923 89.677 80.7728C89.5859 78.16 89.7043 74.7762 90.5562 72.0166C91.4111 69.2489 92.8523 67.4955 95.2128 67.2706V64.7294C92.8524 64.5038 91.4112 62.7511 90.5562 59.9834C89.7042 57.2242 89.5859 53.84 89.677 51.2272C89.772 48.5081 87.6524 46 84.7873 46H55.429H55.4294ZM79.0426 70.6226C79.0426 74.3673 76.2494 76.6383 71.6141 76.6383H63.7234C63.4977 76.6383 63.2812 76.5487 63.1216 76.3891C62.962 76.2295 62.8723 76.013 62.8723 75.7873V56.2128C62.8723 55.9871 62.962 55.7706 63.1216 55.611C63.2812 55.4514 63.4977 55.3617 63.7234 55.3617H71.5692C75.4343 55.3617 77.9709 57.4554 77.9709 60.6698C77.9709 62.9259 76.2644 64.9457 74.0905 65.2996V65.4173C77.0499 65.7419 79.0426 67.7916 79.0426 70.6226ZM70.7537 58.0596H66.2545V64.4147H70.0439C72.9733 64.4147 74.5886 63.2351 74.5886 61.1266C74.5883 59.1507 73.1996 58.0596 70.7537 58.0596ZM66.2545 66.9362V73.9396H70.9192C73.9693 73.9396 75.5848 72.7158 75.5848 70.4158C75.5848 68.1158 73.924 66.9358 70.7231 66.9358H66.2545V66.9362Z",
    fill: "#7952B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 59,
    height: 59,
    rx: 5.5,
    stroke: "#04B2AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_854_13750",
    x: 0,
    y: 0,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_854_13750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_854_13750",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.cac9fdc599af7ed9b214db5c27871418.svg";
export { ForwardRef as ReactComponent };